<div class="headerWrapper">
  <div></div> <!--Spacer left-->
  <div class="center">
    <div>
      <uik-svg-icon (click)="backButtonService.onBackButtonClick()" *ngIf="backButtonService.isBackButtonVisible()"
                    [customIconPath]="'assets/images/icons/'" iconStyle="svg-icon-small"
                    id="backButton" name="left_arrow"></uik-svg-icon>
      <div *ngIf="!backButtonService.isBackButtonVisible()" class="spacerDummy"></div>
    </div>
    <div class="logo">
      <img (click)="sunny()" *ngIf="sun < 10" src='assets/images/CloudLogoNoText_Blue.svg' alt='cloud icon'>
      <p *ngIf="sun >= 10" style="font-size:25px; margin: 2px">👌</p>
      <div class="titleWrapper" id="title"><span>Rollout Assistant</span></div>
    </div>
    <div></div> <!--Spacer right-->
  </div>
  <div></div> <!--Spacer right-->
</div>

<uik-label *ngIf="!online" [text]="'OFFLINE'" [type]="'danger'" class="offlineLabel" id="offlineLabel"></uik-label>
